import { Injectable, Injector } from '@angular/core';
import { ITriggerConfigService } from '../../components/workflow-config/actions/actionConfigs/itriggerconfig.service';
import {SalesforceTriggerConfigService} from '../../components/workflow-config/actions/actionConfigs/salesforce-trigger-config.service';
import { IDocMergeAllowedEntitiesService } from '../../components/workflow-config/allowedEntities/IDocMergeAllowedEntitiesService';
import { SalesforceDocMergeAllowedEntitiesService } from '../../components/workflow-config/allowedEntities/SalesforceDocMergeAllowedEntitiesService';
import { IDocMergeAllowedSectionsService } from '../../components/workflow-config/allowedSections/IDocMergeAllowedSectionsService';
import { SalesforceDocMergeAllowedSectionsService } from '../../components/workflow-config/allowedSections/SalesforceDocMergeAllowedSectionsService';
import { ISignatureDataFormatterService } from '../../interfaces/ISignatureDataFormatterService';
import { IDocumentDestinationService } from '../../model/interfaces/idocumentdestinationservice';
import { IAttachmentSourceOptionLabelService } from '../attachment-source-options/iattachment-source-option-label.service';
import { SalesforceAttachmentSourceOptionLabelService } from '../attachment-source-options/salesforce-attachment-source-option-label.service';
import { SalesforceDocumentDestinationService } from '../document-destination/salesforce.document-destination.service';
import {SalesforceSignatureFormatterService} from '../signature-formatters/salesforce-signature-formatter.service';
import { IServiceProviderService } from './iserviceproviderservice';

@Injectable({ providedIn: 'root' })
export class SalesforceServiceProviderService implements IServiceProviderService {
  constructor(private injector: Injector) {}

  getDocumentDestinationService(): IDocumentDestinationService {
    return this.injector.get(SalesforceDocumentDestinationService);
  }

  getSignatureDataFormatterService(): ISignatureDataFormatterService {
    return this.injector.get(SalesforceSignatureFormatterService);
  }

  getTriggerConfigService(): ITriggerConfigService {
    return this.injector.get(SalesforceTriggerConfigService);
  }

  getDocMergeAllowedEntitiesService(): IDocMergeAllowedEntitiesService {
    return this.injector.get(SalesforceDocMergeAllowedEntitiesService);
  }

  getDocMergeAllowedSectionsService(): IDocMergeAllowedSectionsService {
    return this.injector.get(SalesforceDocMergeAllowedSectionsService);
  }

  getAttachmentSourceOptionLabelService(): IAttachmentSourceOptionLabelService {
    return this.injector.get(SalesforceAttachmentSourceOptionLabelService);
  }
}
